<div class="maxWidthMaxHeight">
    <router-outlet></router-outlet>
    <!-- <h1>Preferences</h1> -->
    <!-- <mat-tab-group class="maxWidthMaxHeight" fxFlex>
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon" style="margin-right: 0.5em;">price_change</mat-icon>
                Price Shift
            </ng-template>
            <app-price-shift></app-price-shift>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon" style="margin-right: 0.5em;">request_quote</mat-icon>
                Price Level
            </ng-template>
            <app-price-level></app-price-level>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon" style="margin-right: 0.5em;">monetization_on</mat-icon>
                Cost Level
            </ng-template>
            <app-cost-level></app-cost-level>
        </mat-tab>
    </mat-tab-group> -->
</div>